/**
 * Check if two numbers as equal based on how close enough they are to each other.
 * @param {Number} first
 * @param {Number} last
 * @returns {Boolean}
 */
export function numbersAreEqual(first, second, tolerance = Number.EPSILON) {
  return Math.abs(first - second) < tolerance;
}
